import {
  MARK_ATTENDANCE_REQUEST,
  MARK_ATTENDANCE_SUCCESS,
  MARK_ATTENDANCE_FAILURE,
  RESET_ATTENDANCE_STATE,
} from "../actions/actionTypes";

const initialState = {
  isSubmitting: false,
  lastAttendType: null,
  success: false,
  error: null,
};

export default function attendanceReducer(state = initialState, action) {
  switch (action.type) {
    case MARK_ATTENDANCE_REQUEST:
      return { ...state, isSubmitting: true, success: false, error: null };
    case MARK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: true,
        lastAttendType: action.payload,
      };
    case MARK_ATTENDANCE_FAILURE:
      return { ...state, isSubmitting: false, success: false, error: action.payload };
    case RESET_ATTENDANCE_STATE:
      return initialState;
    default:
      return state;
  }
}
